const company = "CMRC";
const project = "门户";
export default {
    state: {
        company: company,  // 公司
        project: project,  // 应用名称
        appName: `${company}${project}`,  // 应用名称
        menuRouteLoaded: false,    // 菜单和路由是否已经加载
        requestLoading: 0,
    },
    getters: {
    },
    mutations: {
        menuRouteLoaded(state, menuRouteLoaded){  // 改变菜单和路由的加载状态
            state.menuRouteLoaded = menuRouteLoaded;
        },
        SET_LOADING: (state, status) => {
            
            // error 的时候直接重置
            if (status === 0) {
                state.requestLoading = 0;
                return;
            }
            state.requestLoading = status ? ++state.requestLoading : --state.requestLoading;
        },
    },
    actions: {
        SetLoading({ commit }, status) {
            commit('SET_LOADING', status);
        },
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/app.js